export const TabTitles = {
    PAGES: 'Click Products tab on left to add products.',
    FRONT_BACK_COVER_BROCHURE: 'Click "Right/Left Inside" page and then select Products and Images tabs to add content.',
    FRONT_BACK_COVER_CATALOG: 'Click a page on the left to add content.',
    FRONT_BACK_POSTCARD: 'Click "Front" page and then select Products and Images tabs to add content.',
    PRODUCTS: 'Click and drag products to placeholders.',
    PRODUCT_FOR_SINGLE_PLACEHOLDER: 'Click and drag product to placeholder.',
    IMAGES: 'Click and drag images to placeholders.',
    OBJECTS: 'Click and drag Extras to placeholders.',
};



// WEBPACK FOOTER //
// ./src/infrastructure/TabTitles.ts